import { memo } from 'react';
import LessonsSchedule from 'components/LessonsSchedule/LessonsSchedule';

export default memo(LessonsSchedule);
